export const colors = {
  medColor: 'hsl(54, 98%, 66%)',
  newColor: 'hsl(26, 100%, 67%)',
  knowColor: 'hsl(145, 63%, 49%)'
}

export const colorsLight = {
  medColorLight: 'hsl(54, 98%, 95%)',
  newColorLight: 'hsl(26, 100%, 95%)',
  knowColorLight: 'hsl(145, 63%, 85%)'
}

export const libraryColor = {
  base: '#0000ff',
  light: '#b9b9ff',
  lighter: '#dbdbfc',
}


export const fonts = {
  appFont: "'Viaoda Libre', cursive",
  secondaryFont: "'Inconsolata', monospace",
  mainFont: "'Nunito', sans-serif",
}

export const maxWidths = {
  background: "600px",
  content: "500px",
}

